import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { adminBotSocket, spotSocket } from 'src/app/app.module';
import { fraction, longDecimals, nFormatter, toFixed, toFixedDown, truncateDecimals } from 'src/app/lib/roundOf';
import { adminBotService } from 'src/app/services/bot.admin.service';
import { TradePairFacade } from 'src/app/store/bottradepair';
import { WalletService } from 'src/app/services/wallet.service';
import { AuthFacade } from 'src/app/store/auth';
import { TradeAssetFacade } from 'src/app/store/bot-trade-asset';
import { PairFacade } from 'src/app/store/botpair';
import { PositionDetailsFacade } from 'src/app/store/positionDetails';
import isEmpty from 'src/app/lib/isEmpty';

@Component({
  selector: 'app-recentTrade',
  templateUrl: './recentTrade.component.html',
  styleUrls: ['./recentTrade.component.css']
})
export class recentTradeComponent {
  toFixedDown = toFixedDown
  toFixed = toFixed
  truncateDecimals = truncateDecimals
  longDecimals = longDecimals
  fraction = fraction
  nFormatter = nFormatter

  pairs: any = {}
  tradePair: any = {}
  topGainers: any = []
  recentTrade: any = []
  auth: any = {}
  searchPair: string = ''
  activePair: string = ''


  constructor(
    private pairFacade: PairFacade,
    private router: Router,
    private route: ActivatedRoute,
    private location: Location,
    private service: adminBotService,
    private authFacade: AuthFacade,
    private walletService: WalletService,
    private tradeAssetFacade: TradeAssetFacade,
    private positionDetails: PositionDetailsFacade,
    private spotSocket: spotSocket,
    private botSocket: adminBotSocket,
    private tradePairFacade: TradePairFacade,
  ) {
    this.authFacade.auth$.subscribe({
      next: (userAuth: any) => {
        this.auth = userAuth
      },
      error: (err: any) => { }
    })
  }

  pairChange() {
    this.recentTrade = []
    this.tradePairFacade.tradePair$.subscribe({
      next: (selectPair: any) => {
        if (!isEmpty(selectPair)) {
          let selectedSymbol = selectPair.firstCurrencySymbol + selectPair.secondCurrencySymbol
          const fullPair = this.pairs.find((v: any) => v.symbol === selectedSymbol);
          if (fullPair) this.tradePair = fullPair
          let symbol = selectPair.firstCurrencySymbol + "_" + selectPair.secondCurrencySymbol;
          this.activePair = symbol;
          this.getRecentTrade(selectedSymbol)
        }
      },
      error: (err: any) => { }
    })
  }

  getPairs() {
    this.pairFacade.pair$.subscribe({
      next: (pair: any) => {
        this.pairs = pair
        const fullPair = this.pairs.find((v: any) => v.symbol === this.activePair.replace("_", ""));
        if (fullPair) this.tradePair = fullPair
        this.pairChange()
      },
      error: (err: any) => { }
    })
  }
  ngOnInit() {
    this.getPairs()
    const currentPath = this.location.path();
    this.activePair = currentPath.split('/')[2];
    this.botSocket.on('vampRecentTrade', this.updateRecentTrade.bind(this))
    this.getRecentTrade(this.activePair.replace("_", ""))

  }
  updateRecentTrade(result: any) {
    // 1. Validation and Setup
    if (!result || typeof result !== 'object' || Array.isArray(result) || !result.symbol) {
      console.error('Invalid result format or missing symbol:', result);
      return;
    }
    if (result.symbol == this.activePair.replace("_", "")) {
      let data = this.recentTrade.slice(0, -1);
      this.recentTrade = [...result.data, ...data]
    }
  }

  handleSearchPair(event: any) {
    this.searchPair = event.target.value.toUpperCase().replace('/', '')
  }
  changePair(pair: any) {
    const newPair = pair.symbol
    if (newPair == this.activePair.replace("_", "")) return;

    // this.socketService.emit("unSubscribe", activePair.replace("_", ""));
    this.botSocket.emit("unSubscribe", this.activePair.replace("_", ""));
    window.location.href = '/adminBot/' + newPair
    // this.service.setTradePair(pair)
    this.positionDetails.setPosition({})
  }

  getRecentTrade(activePair: string) {
    if (!this.auth.signedIn) {
      return
    }
    this.service.getRecentTrade(activePair)
      .subscribe({
        next: (v: any) => {
          if (v.success) {
            this.recentTrade = v.result.slice(0, 20)
          }
        },
        error: (err: any) => {
        }
      })
  }

  // 24H Change gainers losers sorting
  changeSort: 'gainers' | 'losers' | '' = '';

  toggleChangeSort() {
    if (this.changeSort === '') {
      this.changeSort = 'gainers';
    } else if (this.changeSort === 'gainers') {
      this.changeSort = 'losers';
    } else {
      this.changeSort = '';
    }
    this.sortPairs();
  }

  sortPairs() {
    const pairsCopy = [...this.pairs];
    if (this.changeSort === 'gainers') {
      this.pairs = pairsCopy.sort((a, b) => (b.change || 0) - (a.change || 0));
    } else if (this.changeSort === 'losers') {
      this.pairs = pairsCopy.sort((a, b) => (a.change || 0) - (b.change || 0));
    } else {
      this.pairs = pairsCopy;
    }
  }

}
